import { Col, Container, Row } from "react-bootstrap";
import "./faculty.css";
import MainSubHeading from "../Sub-Heading/MainSubHeading";
import facultyData from "./facultyData";

export default function Faculty() {

  const subheadingData = "Hub Governing Board";

  return (
    <Container>
      <MainSubHeading subheading={subheadingData} />

      <Row>
        {facultyData.map((faculty) => (
          <Col xs={12} md={6} className="p-4" key={faculty.id}>
            <div className="faculty-bx">
              <Row className="m-0 cus_hub_team_row">
                
                <Col xs={12} sm={12} md={5} lg={4} className="p-sm-2 p-md-4">
                  <img
                    src={faculty.image}
                    alt={faculty.name}
                    className="img-fluid rounded-4"
                  />
                </Col>

                <Col xs={12} sm={12} md={7} lg={8} className="p-2 pt-0 pt-md-4">
                  <h4 className="faculty-main-head fw-bold">
                    {faculty.name}
                  </h4>

                  <h6 className="faculty-sub-head">
                    {faculty.role}
                  </h6>
                </Col>

              </Row>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}